<div class="view-container">
  <div class="top-bar">
    <span class="label"></span>
    <customer-portal-kc-localization-menu
      class="localizationMenu"
    ></customer-portal-kc-localization-menu>
  </div>
  <div class="login">
    <div class="form-container">
      <h2 class="ef-headline-3">
        <T
          str="Review company details"
          key="customerPortal.kc.review-business.title"
          tags="kc-forms, 3.1"
        ></T>
      </h2>
      <div>
        <mat-divider></mat-divider>
        <div class="panel">
          <div class="header">
            <div class="panel-icon">
              <mat-icon class="icon">business</mat-icon>
            </div>
            <div class="text">
              <div class="panel-heading">
                <T
                  str="Company name"
                  key="customerPortal.kc.review-business.company-name"
                  tags="kc-forms, 3.1"
                ></T>
              </div>
              <div class="panel-text">
                {{ viewData.companyName ? viewData.companyName : ' - ' }}
              </div>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="panel">
          <div class="header">
            <div class="panel-icon">
              <mat-icon class="icon">verified_user</mat-icon>
            </div>
            <div class="text">
              <div class="panel-heading">
                <T
                  str="Uid"
                  key="customerPortal.kc.review-business.uid"
                  tags="kc-forms, 3.1"
                ></T>
              </div>
              <div class="panel-text">
                {{ viewData.companyNumber ? viewData.companyNumber : ' - ' }}
              </div>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="panel">
          <div class="header">
            <div class="panel-icon">
              <mat-icon class="icon">gps_fixed</mat-icon>
            </div>
            <div class="text">
              <div class="panel-heading">
                {{ 'address' | sharedTranslate }}
              </div>
              <div class="panel-text">
                {{ viewData.address || '' }}
                {{ viewData.zip ? ', ' + viewData.zip : '' }}
                {{ viewData.city ? ', ' + viewData.city : '' }}
                {{ viewData.country ? ', ' + viewData.country : '' }}
              </div>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <form
          #companyDetailsForm
          [action]="viewData.registrationAction"
          method="POST"
          (ngSubmit)="login()"
        >
          <div class="company-buttons">
            <button
              mat-button
              mat-flat-button
              color="primary"
              class="login-button"
              type="submit"
              (click)="form.patchValue({ action: 'finish' })"
            >
              <T
                str="Finish"
                key="customerPortal.kc.review-business.finish"
                tags="kc-forms, 3.1"
              ></T>
            </button>
            <div class="link" [hidden]="companyRelation === 'driver'">
              <T
                str="Something not right?"
                key="customerPortal.kc.review-business.change.title"
                tags="kc-forms, 3.1"
              ></T>
              <button
                class="change-button"
                type="submit"
                (click)="form.patchValue({ action: 'edit' })"
              >
                <T
                  str="Change details"
                  key="customerPortal.kc.review-business.change.link"
                  tags="kc-forms, 3.1"
                ></T>
              </button>
            </div>
          </div>
          <input type="hidden" name="action" [value]="form.value.action" />
        </form>
      </div>
    </div>
  </div>
</div>
